module.exports = __webpack_public_path__ + "static/img/inventario_cajasrefrigeradas.20a14ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/inventario_cajasrefrigeradas.png
// module id = 93
// module chunks = 0